import { COLORS } from '@shared/config/colors/colors';
import { FileDimension } from '../input-file/types';

export const contentStylesByDisabled = ({ disabled }: { disabled?: boolean }) => {
    if (disabled) {
        return `
            border: 1px solid ${COLORS.neutral_50};
            background: ${COLORS.neutral_00};
        `;
    }
};

export const contentStylesByError = ({ isError }: { isError?: boolean }) => {
    if (isError) {
        return `
            border: 1px solid ${COLORS.error_60};
        `;
    }
};

export const contentStylesByDimension = ({ dimension }: { dimension: FileDimension }) => {
    switch (dimension) {
        case 'm': {
            return `
            padding: 10px 16px;
        `;
        }
        case 'l': {
            return `
            padding: 9px 12px;
        `;
        }
        default: {
            return '';
        }
    }
};

export const textStylesByDimension = ({ dimension }: { dimension: FileDimension }) => {
    switch (dimension) {
        case 'm': {
            return `
            flex-direction: row;
            gap: 8px;
        `;
        }
        case 'l': {
            return `
            flex-direction: column;
            gap: 2px;
        `;
        }
        default: {
            return '';
        }
    }
};
